"use client";

import { memo } from "react";
import { HmcAccordion } from "@adi-ctx/harmonic-core-components-react";
import { FilterToggle } from "@/components";
import { t } from "@/utils";

type FilterDriverStatusProps = {
	readonly onChange: (showObsolete: boolean) => void;
};

/**
 * Displays a status (obsolete or not) Toggle component for the drivers
 * @constructor
 */
function FilterDriverStatus(props: FilterDriverStatusProps) {
	return (
		<HmcAccordion isOpen size="md" className="border-b">
			<div slot="header" data-testid="filter-driver-status-title">
				{t("filters.drivers-status-title")}
			</div>

			<div slot="content" className="pb-4 pt-3">
				<FilterToggle
					isChecked
					label={t("filters.drivers-status-label")}
					onChange={props.onChange}
				/>
			</div>
		</HmcAccordion>
	);
}

export default memo(FilterDriverStatus);
